import { styled } from "styled-components";

import type { IWidgetContainerProps } from "app/components/React/WidgetContainer/types";
import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";

import { useMetricsSubtitleFilters } from "./useMetricsSubtitleFilters";

const FullWidthWidgetContainer = styled(WidgetContainer)`
    width: 100%;
`;

export type MetricsWidgetContainerProps = Pick<
    IWidgetContainerProps,
    | "children"
    | "title"
    | "isLoading"
    | "noData"
    | "noDataType"
    | "automationId"
    | "dynamicButtonsConfig"
    | "withBorder"
>;

export const MetricsWidgetContainer = (props: MetricsWidgetContainerProps) => {
    const subtitleFilters = useMetricsSubtitleFilters();

    return (
        <FullWidthWidgetContainer
            {...props}
            loaderWidth="100%"
            loaderHeight={165}
            subtitleFilters={subtitleFilters}
        />
    );
};
